import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import ProjectsList from "../../elements/projects/index";
import ProjectsSearch from "../../elements/projects/widgets/project_search";
import ProjectsExport from '../../elements/projects/widgets/projects_export';

class Projects extends Component {
	render (){
		let { projects } = this.props;
		return <ProjectsList
			{...projects} 
			fetchProjectsList={this.props.fetchProjects}
			filters={projects.filters}
			change={this.props.change}
			key="projects-list"
		/>
	}

	componentWillMount() {
		let { projects } = this.props;
		this.props.fetchProjects(1, projects.filters);
	}

}

export default BaseLayout(Projects,
	{
		title: `Administrar Proyectos`,
		subnav: {
			icon: 'fa-briefcase',
			name: 'Proyectos',
			actions: [
				{
					type: 'search',
					url: null,
					name: 'Buscar',
					element: <ProjectsSearch />
				},
				{
					type: 'element',
					url: null,
					name: 'Exportar',
					element: <ProjectsExport />
				}
			]
		}
	});



// WEBPACK FOOTER //
// ./src/layouts/projects/index.jsx